export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkAgents: "nav-link-agents",
  linkHow: "nav-link-how",
  linkPricing: "nav-link-pricing",
  linkFaq: "nav-link-faq",
  ctaLaunch: "nav-cta-launch",
};

export const HERO = {
  section: "hero-scroll-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  scrollIndicator: "hero-scroll-indicator",
};

export const AGENTS = {
  section: "agents-section",
  card: (id) => `agent-card-${id}`,
};

export const HOW = { section: "how-it-works-section" };
export const LIVE = {
  section: "live-telemetry-section",
  image: "live-telemetry-image",
  ticker: (id) => `live-ticker-${id}`,
};
export const DIAG = {
  section: "diagnostic-mock-section",
  runBtn: "diagnostic-run-btn",
};
export const VIN = {
  section: "vin-lookup-section",
  input: "vin-lookup-input",
  submit: "vin-lookup-submit",
  result: "vin-lookup-result",
};
export const STATS = { section: "stats-section" };
export const PRICING = {
  section: "pricing-section",
  card: (id) => `pricing-card-${id}`,
  cta: (id) => `pricing-cta-${id}`,
};
export const FAQ = {
  section: "faq-section",
  item: (id) => `faq-item-${id}`,
};
export const FOOTER = {
  section: "footer-section",
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
};
